// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import RegistrationModal from 'Containers/Registration/RegistrationModal';

const StyledRegistrationPage = styled.div`
  width: 100vw;
  height: 100vh;
`;

const RegistrationPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let registrationPageClassName = bodyAttributes?.class || '';
  if (!registrationPageClassName.includes('RegistrationPage')) {
    registrationPageClassName += 'RegistrationPage';
  }

  return (
    <>
      <Helmet>
        <body className={ registrationPageClassName } />
        <title>{ t('common.pages.registration') }</title>
      </Helmet>
      <StyledRegistrationPage theme={ theme } className="grid-container">
        <RegistrationModal />
      </StyledRegistrationPage>
    </>
  );
});
RegistrationPage.displayName = 'RegistrationPage';

export default RegistrationPage;
